import script from "./ModalContentProductAddedToBasket.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalContentProductAddedToBasket.vue?vue&type=script&setup=true&lang=js"

import "./ModalContentProductAddedToBasket.vue?vue&type=style&index=0&id=837c3836&scoped=true&lang=css"

import exportComponent from "/Users/darrenlumber/Sites/office-drop-craft/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-837c3836"]])

export default __exports__